<form [formGroup]="filterForm" (ngSubmit)="applyFilter()">
    @if (localTableFilters) {
    <mat-form-field subscriptSizing="dynamic" class="filter">
        <mat-label>Filter</mat-label>
        <mat-select formControlName="tableFilter">
            @for (filter of localTableFilters; track filter) {
            <mat-option [value]="filter">
                {{filter.displayName}}
            </mat-option>
            }
        </mat-select>
    </mat-form-field>
    }

    <mat-form-field subscriptSizing="dynamic" class="filter">
        <mat-label>{{filterForm.value.tableFilter.displayName || ''}}</mat-label>

        @if (isArray()) {
        <mat-select formControlName="value">
            @for (val of filterForm.value.tableFilter.values; track val) {
            <mat-option [value]="val">
                {{val}}
            </mat-option>
            }
        </mat-select>
        } @else {
        <label>
            <input matInput placeholder="{{filterForm.value.tableFilter.displayName || ''}}" formControlName="value">
        </label>
        }

    </mat-form-field>

    <div class="buttons">
        <button mat-flat-button color="primary" class="button" type="submit" [disabled]="isFilterSet()"
            (click)="isSearchClicked()">Search</button>
        @if (filterApplied) {
        <button mat-stroked-button class="button" (click)="reset()">Reset</button>
        }
        @if (hasRoute('/')) {
        <button mat-flat-button color="primary" class="button" (click)="isExcelClicked()">Export</button>
        }
    </div>
</form>
@if (isLoadingResults) {
<div class="loading-shade">
    @if (isLoadingResults) {
    <mat-spinner></mat-spinner>
    }
</div>
}